import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DataProcessContainer } from '../../Model/dataProcess/dataprocesscontainer';

@Injectable()
export class DataProcessContainerService {
  private readonly apiUrl = 'api/DataProcessContainer';

  constructor(private http: HttpClient) {}

  public get(id: string, customerId: string): Promise<DataProcessContainer> {
    const url = `${this.apiUrl}/get`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<DataProcessContainer>(url, options));
  }

  public getAll(customerId: string): Promise<DataProcessContainer[]> {
    const url = `${this.apiUrl}/getAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<DataProcessContainer[]>(url, options));
  }

  public create(model: DataProcessContainer, customerId: string): Promise<DataProcessContainer> {
    const url = `${this.apiUrl}/create`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<DataProcessContainer>(url, model, options));
  }

  public update(model: DataProcessContainer, customerId: string): Promise<DataProcessContainer> {
    const url = `${this.apiUrl}/update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<DataProcessContainer>(url, model, options));
  }

  public delete(id: string, customerId: string): Promise<DataProcessContainer> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<DataProcessContainer>(url, options));
  }

  public deleteIcon(id: string, customerId: string): Promise<void> {
    const url = `${this.apiUrl}/deleteIcon`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<void>(url, options));
  }
}
